/* unplugin-vue-components disabled */import { render } from "./NoticeInfoModal.vue?vue&type=template&id=00a3aa24"
import script from "./NoticeInfoModal.vue?vue&type=script&lang=js"
export * from "./NoticeInfoModal.vue?vue&type=script&lang=js"

import "./NoticeInfoModal.vue?vue&type=style&index=0&id=00a3aa24&lang=scss"

import exportComponent from "/home/forge/app.juker3.com/releases/20250105151848/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__